import { render, staticRenderFns } from "./AreaCode.vue?vue&type=template&id=2204ca3c&scoped=true&"
import script from "./AreaCode.vue?vue&type=script&lang=js&"
export * from "./AreaCode.vue?vue&type=script&lang=js&"
import style0 from "./AreaCode.vue?vue&type=style&index=0&id=2204ca3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204ca3c",
  null
  
)

export default component.exports